import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoEstado } from '../../../_models/producto-estado';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FuncionalidadesService } from '../../../_services/funcionalidades.service';
import { ProductoEstadoRelacionService } from '../../../_services/producto-estado-relacion.service';
import { FuncionalidadControl } from '../../../_models/funcionalidad-control';
import { ProductoEstadoRelacion } from '../../../_models/producto-estado-relacion';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';
import { ProductoEstadoRelacionCausalService } from '../../../_services/producto-estado-relacion-causal.service';
import { ProductoEstadoRelacionCausal } from '../../../_models/producto-estado-relacion-causal';
import { TipoCausalCausalSolicitudService } from '../../../_services/tipo-causal-causal-solicitud.service';
import { TipoCausalCausalSolicitud } from '../../../_models/tipo-causal-causal-solicitud';
import { NotificacionesService } from '../../../_services/notificaciones.service';
import { Notificaciones } from '../../../_models/notificaciones';
import { ProductoEstadoRelacionNotificacion } from '../../../_models/producto-estado-relacion-notificacion';
import { ProductoEstadoRelacionNotificacionService } from '../../../_services/producto-estado-relacion-notificacion.service';
import { ProductosEstadosRelacionesTiposPreaprobados } from '../../../_models/productos-estados-relaciones-tipos-preaprobados';
import { ProductosEstadosRelacionesTiposPreaprobadosService } from '../../../_services/productos-estados-relaciones-tipos-preaprobados.service';

@Component({
  selector: 'app-producto-estado-aliado-relacion',
  templateUrl: 'producto-estado-aliado-relacion.component.html'
})

export class ProductoEstadoAliadoRelacionComponent implements OnInit {

  @Input() proEstado: ProductoEstado;
  @Input() aliado: boolean;
  @Input() lisTodosEstados: ProductoEstado[] = [];
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  lisFuncionalidadesControles: FuncionalidadControl[] = [];
  lisProductoEstadoCambio: ProductoEstadoRelacion[] = [];
  lisEstados: SelectItem[] = [];
  proEstadoCambioSeleccionado: ProductoEstadoRelacion;
  lisFormularios: SelectItem[] = [];
  lisControles: SelectItem[] = [];
  lisFases: SelectItem[] = [];
  seccion = 'LISTADO';
  lisTiposCausales: SelectItem[] = [];
  lisCausales: SelectItem[] = [];
  lisProductoRelacionCausal: ProductoEstadoRelacionCausal[] = [];
  mosCausales = false;
  colCausales: any[] = [];
  lisCausalesSeleccionadas: ProductoEstadoRelacionCausal[] = [];
  lisTodasTiposCausales: TipoCausalCausalSolicitud[] = [];
  lisNotificaciones: SelectItem[] = [];
  lisProductoEstadoRelacionNotificacion: ProductoEstadoRelacionNotificacion[] = [];
  lisTiposPreAprobados: SelectItem[] = [];
  lisTiposPreAprobadosTemp: ListaItem[] = [];
  listRelacionTipoPreaprobados: ProductosEstadosRelacionesTiposPreaprobados[] = [];

  constructor(private navServicio: NavService,
    private conServicio: ConfirmationService,
    private proEstadoCambioServicio: ProductoEstadoRelacionService,
    private fb: FormBuilder,
    private lisServicio: ListaService,
    private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
    private tipCausalesService: TipoCausalCausalSolicitudService,
    private funServicio: FuncionalidadesService,
    private proEstadoRelacionNotificacionServicio: ProductoEstadoRelacionNotificacionService,
    private proEstadoRelacionTipoPreAprobado: ProductosEstadosRelacionesTiposPreaprobadosService,
    private notServicio: NotificacionesService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreEstadoPrincipal', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_DESDEESTADO'), sort: false },
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_HASTAESTADO'), sort: false },
      { field: 'indicadorMantieneFase', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_INDICADORFASE'), sort: false },
      { field: 'nombreFuncionalidadPadre', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_FORMULARIO'), sort: false },
      { field: 'nombreFuncionalidadHijo', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_CONTROL'), sort: false },
      { field: 'indicadorSolicitudTradicional', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_SOLICITUD'), sort: false },
      { field: 'preAprobado', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_PREAPROBADO'), sort: false },
      { field: 'indicadorAprobacion', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_APROBACION'), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];

    this.colCausales = [
      { field: 'nombreCausal', header: this.navServicio.buscarMensaje('PRODUCTOESTADO.LBL_CAUSALES'), sort: true }
    ];

    forkJoin(this.proEstadoCambioServicio.listadoPorProductoEstado(this.proEstado.idProductoEstado),
      this.funServicio.obtenerFuncionalidadesControlesPorCodigoFuncionalidad('PRODUCTO'),
      this.lisServicio.getMasterDetails('ListasFases'),
      this.lisServicio.getMasterDetails('ListasTiposCausalesSolicitudes'),
      this.proEstadoRelacionCausalServicio.listadoPorProductoEstado(this.proEstado.idProductoEstado),
      this.tipCausalesService.listadoHabilitados(),
      this.notServicio.getEnabled(),
      this.proEstadoRelacionNotificacionServicio.listadoPorProductoEstado(this.proEstado.idProductoEstado),
      this.lisServicio.getMasterDetails('ListasTiposPreaprobados'),
      this.proEstadoRelacionTipoPreAprobado.listado()
    ).subscribe(([lisProductosEstadosCambio, lisFuncionaliadesControles, lisFases, lisTiposCausales,
      lisCausalesProducto, lisTipCausales, lisNotificaciones, lisProductoEstadoNotificaciones, lisTipoPreAprobados, lisTiposPreAprobadosHabilitados]) => {
      this.listRelacionTipoPreaprobados = lisTiposPreAprobadosHabilitados;
      this.lisFuncionalidadesControles = lisFuncionaliadesControles;
      this.lisTodasTiposCausales = lisTipCausales;
      this.lisProductoRelacionCausal = lisCausalesProducto.filter(x => x.indicadorHabilitado);
      this.lisProductoEstadoRelacionNotificacion = lisProductoEstadoNotificaciones;
      lisNotificaciones.map((s: Notificaciones) => {
        this.lisNotificaciones.push({ label: (s.codigo + ' - ' + s.nombre), value: s.idNotificacion });
      });
      lisProductosEstadosCambio.map((s: ProductoEstadoRelacion) => {
        s.nombreEstadoPrincipal = this.proEstado.nombreEstado;
        s.preAprobado = s.indicadorPreaprobado ?  this.unirTipoPreAprobado(s.idProductoEstadoRelacion) : '';
        this.lisProductoEstadoCambio.push(s);
      });
      lisTiposCausales.map((s: ListaItem) => {
        this.lisTiposCausales.push({ label: s.nombre, value: s.idLista });
      });
      this.lisTiposPreAprobadosTemp = lisTipoPreAprobados;
      lisTipoPreAprobados.map((s: ListaItem) => {
        this.lisTiposPreAprobados.push({ label: s.nombre, value: s.idLista })
      })
      this.cargarFormulario();
      this.cargarListadoEstados();
      this.cargarListadoFormularios();
      this.cargarFases(lisFases);
      this.carInformacionInicial = false;
    });
  }

  cargarListadoEstados() {
    this.lisEstados = [];
    this.lisTodosEstados.map((s: ProductoEstado) => {
      if (s.idEstado !== this.proEstado.idEstado) {
        this.lisEstados.push({ label: s.nombreEstado, value: s.idEstado });
      }
    });
  }

  cargarListadoFormularios() {
    this.lisFormularios = [];
    this.lisFuncionalidadesControles.map((s: FuncionalidadControl) => {
      if (s.indicadorSeccion) {
        this.lisFormularios.push({ label: s.nombre, value: s.idFuncionalidadControl });
      }
    });
  }

  cargarListadoControles(formulario: string) {
    this.lisControles = [];
    this.lisFuncionalidadesControles.map((s: FuncionalidadControl) => {
      if (s.idPadre === formulario && !s.indicadorSeccion) {
        this.lisControles.push({ label: s.nombre, value: s.idFuncionalidadControl });
      }
    });
  }

  cargarFases(lisFases: ListaItem[]) {
    this.lisFases = [];
    lisFases.map((s: ListaItem) => {
      this.lisFases.push({ label: s.nombre, value: s.idLista });
    });
  }


  cambioTipoCausal(idTipo: string, noBorrar?: boolean) {

    this.lisCausales = [];
    this.lisTodasTiposCausales.map((s: TipoCausalCausalSolicitud) => {
      if (s.idListaTipoCausalSolicitud == idTipo && s.indicadorHabilitado) {
        this.lisCausales.push({ label: s.nombreListaCausalSolicitud, value: s.idTipoCausalCausalSolicitud });
      }
    });

    this.f.causales.clearValidators();
    if (idTipo !== '' && idTipo !== null && idTipo !== undefined ) {
      this.f.causales.setValidators([Validators.required]);
    } else {
      this.f.causales.setValidators([]);
    }

    if (!noBorrar) {
      this.f.causales.setValue([]);
    }


  }

  cargarFormulario() {
    const causales = [];
    let idTipoCausal = null;
    this.lisProductoRelacionCausal.map((s: ProductoEstadoRelacionCausal) => {
      if (this.proEstadoCambioSeleccionado && this.proEstadoCambioSeleccionado.idProductoEstadoRelacion === s.idProductoEstadoRelacion) {
        if (!idTipoCausal) {
          idTipoCausal = s.idTipoCausal;
        }
        causales.push(s.idTipoCausalCausalSolicitud);
      }
    });


    const notificaciones = [];
    if (this.proEstadoCambioSeleccionado && this.proEstadoCambioSeleccionado.indicadorManejaNotificaciones) {
      this.lisProductoEstadoRelacionNotificacion.map((s: ProductoEstadoRelacionNotificacion) => {
        if (s.indicadorHabilitado && this.proEstadoCambioSeleccionado.idProductoEstadoRelacion === s.idProductoEstadoRelacion) {
          notificaciones.push(s.idNotificacion);
        }
      });
    }

    const tiposPreAprobados = [];
    if (this.proEstadoCambioSeleccionado && this.proEstadoCambioSeleccionado.indicadorPreaprobado) {
      this.listRelacionTipoPreaprobados.map((s: ProductosEstadosRelacionesTiposPreaprobados) => {
        if (s.indicadorHabilitado && this.proEstadoCambioSeleccionado.idProductoEstadoRelacion === s.idProductoEstadoRelacion) {
          tiposPreAprobados.push(s.idListaTipoPreaprobado);
        }
      });
    }


    this.formulario = this.fb.group({
      idProductoEstadoRelacion: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idProductoEstadoRelacion : null],
      idProductoEstado: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idProductoEstado : this.proEstado.idProductoEstado, [Validators.required]],
      idEstado: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idEstado : null, [Validators.required]],
      idFase: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idFase : null, (this.proEstadoCambioSeleccionado ? (this.proEstadoCambioSeleccionado.indicadorMantieneFase ? [] : [Validators.required]) : [])],
      idFuncionalidadControlPadre: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idFuncionalidadControlPadre : null, [Validators.required]],
      idFuncionalidadControlHijo: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.idFuncionalidadControlHijo : null, [Validators.required]],
      indicadorMantieneFase: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.indicadorMantieneFase : true],
      indicadorPreaprobado: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.indicadorPreaprobado : false],
      tiposPreAprobado: [tiposPreAprobados, (this.proEstadoCambioSeleccionado && this.proEstadoCambioSeleccionado.indicadorPreaprobado) ? [Validators.required] : []],
      indicadorSolicitudTradicional: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.indicadorSolicitudTradicional : false],
      indicadorAprobacion: [this.proEstadoCambioSeleccionado ? (this.proEstadoCambioSeleccionado.indicadorAprobacion || false) : false],
      indicadorManejaNotificaciones: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.indicadorManejaNotificaciones : false],
      indicadorHabilitado: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.indicadorHabilitado : true],
      auditoriaFecha: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.auditoriaFecha : null],
      auditoriaUsuario: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.auditoriaUsuario : null],
      nombreEstadoPrincipal: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.nombreEstadoPrincipal : this.proEstado.nombreEstado],
      nombreEstado: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.nombreEstado : null],
      nombreFuncionalidadPadre: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.nombreFuncionalidadPadre : null],
      nombreFuncionalidadHijo: [this.proEstadoCambioSeleccionado ? this.proEstadoCambioSeleccionado.nombreFuncionalidadHijo : null],
      idNotificaciones: [notificaciones, (this.proEstadoCambioSeleccionado && this.proEstadoCambioSeleccionado.indicadorManejaNotificaciones) ? [Validators.required] : []],
      idTipoCausal: [idTipoCausal],
      causales: [causales],
      preAprobado: [null]
    });
    this.cambioTipoCausal(idTipoCausal, true);
  }

  get f() {
    return this.formulario.controls;
  }

  validacionExistoGuardar(proEstadoCambio: any, actualizar: boolean) {
    const a = this.lisTodosEstados.find(x => x.idEstado === proEstadoCambio.idEstado);
    if (a) {
      proEstadoCambio.nombreEstado = a.nombreEstado;
    }

    const nomFormulario = this.lisFormularios.find(x => x.value === proEstadoCambio.idFuncionalidadControlPadre);
    if (nomFormulario) {
      proEstadoCambio.nombreFuncionalidadPadre = nomFormulario.label;
    }

    const nomControl = this.lisControles.find(x => x.value === proEstadoCambio.idFuncionalidadControlHijo);
    if (nomControl) {
      proEstadoCambio.nombreFuncionalidadHijo = nomControl.label;
    }

    if (actualizar) {
      const busRegistro = this.lisProductoEstadoCambio.findIndex(x => x.idProductoEstadoRelacion === proEstadoCambio.idProductoEstadoRelacion);
      if (busRegistro >= 0) {
        this.lisProductoEstadoCambio[busRegistro] = proEstadoCambio;
      }
    } else {
      this.lisProductoEstadoCambio = [...this.lisProductoEstadoCambio, proEstadoCambio];
    }


    this.proEstadoCambioSeleccionado = null;
    this.cargarFormulario();
    this.cargarListadoEstados();
    this.lisControles = [];
    this.submitted = false;
    this.guardando = false;
    this.navServicio.setMesage(actualizar ? 2 : 1);
  }

  validarExisteTipoPreAprobado(proEstadoRelacion: ProductoEstadoRelacion, ids: string[]): boolean {
    return !!this.listRelacionTipoPreaprobados.find(y => y.indicadorHabilitado && !!ids.find(m => m === y.idListaTipoPreaprobado) && proEstadoRelacion.idProductoEstadoRelacion === y.idProductoEstadoRelacion);
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      const proEstadoCambio = this.formulario.value;
      if( !!this.lisProductoEstadoCambio.find(x => (!proEstadoCambio.idProductoEstadoRelacion || proEstadoCambio.idProductoEstadoRelacion !== x.idProductoEstadoRelacion) && x.idFuncionalidadControlPadre == proEstadoCambio.idFuncionalidadControlPadre && x.idFuncionalidadControlHijo == proEstadoCambio.idFuncionalidadControlHijo && ((x.indicadorSolicitudTradicional && proEstadoCambio.indicadorSolicitudTradicional) || (x.indicadorPreaprobado && proEstadoCambio.indicadorPreaprobado && (!proEstadoCambio.tiposPreAprobado || this.validarExisteTipoPreAprobado(x, proEstadoCambio.tiposPreAprobado))))) ){
        this.guardando = false;
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('PRODUCTOESTADO.MSG_YAEXISTEINDICADORES')
        });
        return;
      }


      const regActualizar = [];
      if (!proEstadoCambio.indicadorSolicitudTradicional && !proEstadoCambio.indicadorPreaprobado) {
        this.submitted = false;
        this.guardando = false;
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('PRODUCTOAUTORIZACION.MSG_ERRORINDICADOR')
        });
        return;
      }
      if (proEstadoCambio.causales) {
        proEstadoCambio.causales.map((s: string) => {
          const existe = this.lisProductoRelacionCausal.find(x => x.idTipoCausalCausalSolicitud == s && x.idProductoEstadoRelacion == proEstadoCambio.idProductoEstadoRelacion);
          if (!existe) {
            const nueRegistro = {} as ProductoEstadoRelacionCausal;
            nueRegistro.idProductoEstadoRelacion = proEstadoCambio.idProductoEstadoRelacion;
            nueRegistro.indicadorHabilitado = true;
            nueRegistro.idTipoCausalCausalSolicitud = s;
            regActualizar.push(nueRegistro);
          }
        });
      }


      if (proEstadoCambio.idProductoEstadoRelacion) {
        this.proEstadoCambioServicio.actualizar(proEstadoCambio).subscribe(estado => {
          this.guardarYActualizarTipoPreAprobado(proEstadoCambio.idProductoEstadoRelacion, proEstadoCambio.tiposPreAprobado)
          proEstadoCambio.preAprobado = this.unirTipoPreAprobadoTemp(proEstadoCambio.tiposPreAprobado)
          this.lisProductoRelacionCausal.map((s: ProductoEstadoRelacionCausal) => {
            if (s.idProductoEstadoRelacion == proEstadoCambio.idProductoEstadoRelacion
              && (!proEstadoCambio.causales || !proEstadoCambio.causales.find(x => x == s.idTipoCausalCausalSolicitud))) {
              s.indicadorHabilitado = false;
              regActualizar.push(s);
            }
          });
          if (regActualizar.length > 0) {
            this.proEstadoRelacionCausalServicio.bulk(regActualizar).subscribe(rta => {
              rta.map((s: ProductoEstadoRelacionCausal) => {
                const a = this.lisProductoRelacionCausal.findIndex(x => x.idProductoEstadoRelacionCausal === s.idProductoEstadoRelacionCausal);
                if (a >= 0 && !s.indicadorHabilitado) {
                  this.lisProductoRelacionCausal.splice(a, 1);
                } else if (a < 0) {
                  const valor = this.lisCausales.find(x => x.value == s.idTipoCausalCausalSolicitud);
                  if (valor) {
                    s.nombreCausal = valor.label;
                  }
                  s.idTipoCausal = proEstadoCambio.idTipoCausal;
                  this.lisProductoRelacionCausal.push(s);
                }
              });
              this.verificarNotificaciones(proEstadoCambio, true);
            });
          } else {
            this.verificarNotificaciones(proEstadoCambio, true);
          }
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage(3);
        });
      } else {
        this.proEstadoCambioServicio.crear(proEstadoCambio).subscribe(estado => {
          proEstadoCambio.idProductoEstadoRelacion = estado.idProductoEstadoRelacion;
          proEstadoCambio.nombreEstadoPrincipal = this.proEstado.nombreEstado;
          this.guardarYActualizarTipoPreAprobado(estado.idProductoEstadoRelacion, proEstadoCambio.tiposPreAprobado)
          proEstadoCambio.preAprobado = this.unirTipoPreAprobadoTemp(proEstadoCambio.tiposPreAprobado)
          if (regActualizar.length > 0) {
            regActualizar.map((s: ProductoEstadoRelacionCausal) => {
              s.idProductoEstadoRelacion = estado.idProductoEstadoRelacion;
            });
            this.proEstadoRelacionCausalServicio.bulk(regActualizar).subscribe(rta => {
              rta.map((s: ProductoEstadoRelacionCausal) => {
                const valor = this.lisCausales.find(x => x.value == s.idTipoCausalCausalSolicitud);
                if (valor) {
                  s.nombreCausal = valor.label;
                }
                s.idTipoCausal = proEstadoCambio.idTipoCausal;
                this.lisProductoRelacionCausal.push(s);
              });
              this.verificarNotificaciones(proEstadoCambio, false);
            });
          } else {
            this.verificarNotificaciones(proEstadoCambio, false);
          }

        }, error => {
          this.guardando = false;
          this.navServicio.setMesage(3);
        });
      }
    }

  }

  editar(proEstadoCambio: ProductoEstadoRelacion) {
    this.proEstadoCambioSeleccionado = proEstadoCambio;
    this.cargarListadoControles(this.proEstadoCambioSeleccionado.idFuncionalidadControlPadre);
    this.submitted = false;
    this.cargarFormulario();
  }

  relacionarRoles(proEstadoCambio: ProductoEstadoRelacion) {
    this.proEstadoCambioSeleccionado = proEstadoCambio;
    this.seccion = 'ROLES';
    this.submitted = false;
  }

  inhabilitar(proEstadoCambio: ProductoEstadoRelacion) {
    this.conServicio.confirm({
      message: this.navServicio.buscarMensaje('MSG_INHABILITAR'),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'producto-estado-relacionar',
      accept: () => {
        this.carInformacionInicial = true;
        proEstadoCambio.indicadorHabilitado = false;
        this.proEstadoCambioServicio.actualizar(proEstadoCambio).subscribe(regActualizado => {
          const a = this.lisProductoEstadoCambio.findIndex(x => x.idProductoEstadoRelacion === proEstadoCambio.idProductoEstadoRelacion);
          if (a >= 0) {
            this.lisProductoEstadoCambio.splice(a, 1);
          }
          this.inhabilitarTipoPreAprobado(proEstadoCambio.idProductoEstadoRelacion)
          this.proEstadoCambioSeleccionado = null;
          this.cargarFormulario();
          this.cargarListadoEstados();
          this.lisControles = [];
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage(2);
          this.inhabilitarNotificaciones(proEstadoCambio.idProductoEstadoRelacion);
        });
      },
      reject: () => {
      }
    });
  }

  regresar() {
    this.dismiss.emit(true);
  }

  cambioSeccion(event: boolean) {
    this.proEstadoCambioSeleccionado = null;
    this.cargarFormulario();
    this.lisControles = [];
    this.seccion = 'LISTADO';
  }

  cambioMantieneFase(cambio: boolean) {
    this.f.idFase.clearValidators();
    if (cambio) {
      this.f.idFase.setValidators([]);
      this.f.idFase.setValue(null);
    } else {
      this.f.idFase.setValidators([Validators.required]);
    }
  }

  ver(proRelacion: ProductoEstadoRelacion) {
    this.lisCausalesSeleccionadas = this.lisProductoRelacionCausal.filter(x => x.idProductoEstadoRelacion === proRelacion.idProductoEstadoRelacion);
    this.mosCausales = true;
  }

  cerrar() {
    this.mosCausales = false;
  }

  cambioNotificaciones(cambio: boolean) {
    if (cambio) {
      this.f.idNotificaciones.setValidators([Validators.required]);
    } else {
      this.f.idNotificaciones.setValidators([]);
      this.f.idNotificaciones.setValue([]);
    }
  }

  cambioTipoPreAprobado(cambio: any) {
    if (cambio && cambio.checked) {
      this.f.tiposPreAprobado.setValidators([Validators.required]);
    } else {
      this.f.tiposPreAprobado.setValidators([]);
      this.f.tiposPreAprobado.setValue([]);
    }
  }

  inhabilitarNotificaciones(idProductoEstadoRelacion: string) {
    const idActualizar = [];
    this.lisProductoEstadoRelacionNotificacion.map((s: ProductoEstadoRelacionNotificacion) => {
      if (s.idProductoEstadoRelacion === idProductoEstadoRelacion && s.indicadorHabilitado) {
        s.indicadorHabilitado = false;
        idActualizar.push(s);
      }
    });

    if (idActualizar.length > 0) {
      this.proEstadoRelacionNotificacionServicio.bulk(idActualizar).subscribe(actualizado => {
        this.carInformacionInicial = false;
      });
    } else {
      this.carInformacionInicial = false;
    }

  }

  verificarNotificaciones(proEstadoCambio: any, actualizar: boolean) {
    const registros = [];
    proEstadoCambio.idNotificaciones.map((s: any) => {
      const a = this.lisProductoEstadoRelacionNotificacion.find(x => x.idProductoEstadoRelacion === proEstadoCambio.idProductoEstadoRelacion && x.idNotificacion === s);
      if (a && !a.indicadorHabilitado) {
        a.indicadorHabilitado = true;
        registros.push(a);
      } else if (!a) {
        const nuevo = {} as ProductoEstadoRelacionNotificacion;
        nuevo.idProductoEstadoRelacion = proEstadoCambio.idProductoEstadoRelacion;
        nuevo.idNotificacion = s;
        nuevo.indicadorHabilitado = true;
        registros.push(nuevo);
      }
    });

    this.lisProductoEstadoRelacionNotificacion.map((s: ProductoEstadoRelacionNotificacion) => {
      if (s.idProductoEstadoRelacion === proEstadoCambio.idProductoEstadoRelacion) {
        const a = proEstadoCambio.idNotificaciones.find(x => x === s.idNotificacion);
        if (!a && s.indicadorHabilitado) {
          s.indicadorHabilitado = false;
          registros.push(s);
        }
      }
    });

    if (registros.length > 0) {
      this.proEstadoRelacionNotificacionServicio.bulk(registros).subscribe(listado => {
        listado.map((s: ProductoEstadoRelacionNotificacion) => {
          const b = this.lisProductoEstadoRelacionNotificacion.find(x => x.idNotificacion === s.idNotificacion && s.idProductoEstadoRelacion === x.idProductoEstadoRelacion);
          if (!b) {
            this.lisProductoEstadoRelacionNotificacion.push(s);
          }
        });
        this.validacionExistoGuardar(proEstadoCambio, actualizar);
      });
    } else {
      this.validacionExistoGuardar(proEstadoCambio, actualizar);
    }
  }

  unirTipoPreAprobado(idProductoEstadoRelacion: string) {
    const relaciones = this.listRelacionTipoPreaprobados.filter(l => l.idProductoEstadoRelacion === idProductoEstadoRelacion && l.indicadorHabilitado).map(t => t.tipoPreaprobado);
    if (relaciones.length > 0) {
      return relaciones.join(' - ')
    }
    return '';
  }

  guardarYActualizarTipoPreAprobado(idProductoEstadoRelacion: string, listaTiposPreaprobados: string[]) {
    const resultado = this.listRelacionTipoPreaprobados.filter(l => l.idProductoEstadoRelacion === idProductoEstadoRelacion).map(l => {
      l.indicadorHabilitado = false;
      return l;
    })
    if (resultado.length === 0) {
      listaTiposPreaprobados.map(t => {
        resultado.push({
          id: null,
          idProductoEstadoRelacionTipoPreaprobado: null,
          idProductoEstadoRelacion: idProductoEstadoRelacion,
          idListaTipoPreaprobado: t,
          indicadorHabilitado: true,
          auditoriaUsuario: null,
          auditoriaFecha: null,
          tipoPreaprobado: '',
          codigoTipoPreaprobado: ''
        });
      });
    } else {
      listaTiposPreaprobados.map(l => {
        const search = resultado.find(r => r.idListaTipoPreaprobado === l)
        if (search) {
          search.indicadorHabilitado = true
        } else {
          resultado.push({
            id: null,
            idProductoEstadoRelacionTipoPreaprobado: null,
            idProductoEstadoRelacion: idProductoEstadoRelacion,
            idListaTipoPreaprobado: l,
            indicadorHabilitado: true,
            auditoriaUsuario: null,
            auditoriaFecha: null,
            tipoPreaprobado: '',
            codigoTipoPreaprobado: ''
          })
        }
      })
    }

    this.proEstadoRelacionTipoPreAprobado.crearLista(resultado).subscribe(resp => {
      this.cargarListaTipoPreAprobado()
    });
  }

  cargarListaTipoPreAprobado() {
    this.proEstadoRelacionTipoPreAprobado.listado().subscribe(resp => {
      this.listRelacionTipoPreaprobados = resp;
    })
  }

  inhabilitarTipoPreAprobado(idProductoEstadoRelacion: string) {
    const resultado = this.listRelacionTipoPreaprobados.filter(l => l.idProductoEstadoRelacion === idProductoEstadoRelacion).map(l => {
      l.indicadorHabilitado = false;
      return l;
    })
    if (resultado.length > 0) {
      this.proEstadoRelacionTipoPreAprobado.crearLista(resultado).subscribe(resp => {
        this.cargarListaTipoPreAprobado()
      })
    }
  }

  unirTipoPreAprobadoTemp(listaTiposPreaprobados: string[]) {
    if (listaTiposPreaprobados.length > 0) {
      let tipoPreAprobado = '';
      this.lisTiposPreAprobadosTemp.map((value, key) => {
        if (listaTiposPreaprobados.includes(value.idLista)) {
          tipoPreAprobado += `${value.nombre} ${listaTiposPreaprobados.length === 1 ? '' : (listaTiposPreaprobados.length - 1) === key ? '' : ' - '}`
        }
      })
      return tipoPreAprobado;
    }
    return '';
  }

}
